export default {
    getSummary: (state) => {
        return state.summary
    }
}
